export default __webpack_public_path__ + "static/media/airplay.aabebdc9.svg";